import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpExchange'

export const notificationCreate = (params = '') => Http.post('/create-notifications', params)
